import { render, staticRenderFns } from "./Report-summary.vue?vue&type=template&id=47c22e90"
import script from "./Report-summary.vue?vue&type=script&lang=js"
export * from "./Report-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports